import React from 'react';
import { IconApplicationAccountPlus } from '@sfx/icons';

function UserRequestBanner(props) {
  var prefix = props.prefix,
      translate = props.translate,
      userRequestNumber = props.userRequestNumber,
      onOpen = props.onOpen;
  var componentClass = "".concat(prefix, "-user-request-banner");

  function getUserRequestNumberText(requestNumber) {
    var text = requestNumber < 2 ? translate('SFxAccountSettingsSingleUserRequestNumber', String(requestNumber)) : translate('SFxAccountSettingsMutilUserRequestNumber', String(requestNumber));
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(componentClass, "-link"),
      onClick: onOpen
    }, text);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass)
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(componentClass, "-icon")
  }, " ", /*#__PURE__*/React.createElement(IconApplicationAccountPlus, {
    size: 24
  })), /*#__PURE__*/React.createElement("span", null, translate('SFxAccountSettingsUserRequestBanner', getUserRequestNumberText(userRequestNumber))));
}

export default UserRequestBanner;